export default __webpack_public_path__ + "src/images/btn_zoom_out-354b31.png";